import { Container, Grid } from "@material-ui/core"
import IconButton from "@material-ui/core/IconButton"
import { makeStyles } from "@material-ui/core/styles"
import FacebookIcon from "@material-ui/icons/Facebook"
import TwitterIcon from "@material-ui/icons/Twitter"

const useStyles = makeStyles((theme) => ({
  footer: {
    backgroundColor: '#3f51b5',
    color: "#ffffff",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: 13
  },
  container: { alignItems: "center", justifyContent: "center" },
  copyright: {
    textAlign: "center",
    ["@media (min-width:960px)"]: {
      textAlign: "left",
    },
  },
}))

export default function Footer() {
  const classes = useStyles()
  return (
    <footer className={classes.footer}>
      <Container>
        <Grid container className={classes.container}>
          <Grid item xs={10} className={classes.copyright}>
            <span>
              &copy; Copyright 2021 Rice Department
            </span>
          </Grid>
          <Grid item>
            <IconButton color="inherit" >
              <FacebookIcon />
            </IconButton>
            <IconButton color="inherit" >
              <TwitterIcon />
            </IconButton>
            {/* <IconButton color="inherit" >
              <InstagramIcon />
            </IconButton> */}
          </Grid>
        </Grid>
      </Container>
    </footer>
  )
}
